// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getServiceProviders(appState: ApplicationState): ServiceProvider[]{
  return _getServiceProviders(appState.map) 
}

function _getServiceProviders(state: MapState): ServiceProvider[]{
  return state.serviceProviders
}

getServiceProviders.internal = _getServiceProviders
